import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-analytics';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import * as styles from './allhomes-listing-suburb-info-links.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var SuburbInfoLinks = _ref => {
  var _ref$linkUrl = _ref.linkUrl,
    linkUrl = _ref$linkUrl === void 0 ? '' : _ref$linkUrl,
    _ref$agentLinkUrl = _ref.agentLinkUrl,
    agentLinkUrl = _ref$agentLinkUrl === void 0 ? '' : _ref$agentLinkUrl,
    suburbName = _ref.suburbName,
    _ref$numberOfProperti = _ref.numberOfProperties,
    numberOfProperties = _ref$numberOfProperti === void 0 ? 0 : _ref$numberOfProperti,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {} : _ref$media;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var agentText = "View real estate agents in ".concat(suburbName);
  return ___EmotionJSX("div", {
    css: styles.container
  }, media.mobile && ___EmotionJSX("div", {
    css: styles.title
  }, numberOfProperties, " propert", numberOfProperties > 1 ? 'ies' : 'y', " for sale in ", suburbName), ___EmotionJSX("a", {
    css: styles.infoLink,
    href: linkUrl
  }, ___EmotionJSX("span", {
    css: styles.text
  }, "View ", suburbName, " suburb profile"), ___EmotionJSX(ChevronRightIcon, {
    size: "small"
  })), ___EmotionJSX("a", {
    css: styles.infoLink,
    href: agentLinkUrl,
    onClick: () => sendEvent('view-agents-click', {
      elementText: agentText
    })
  }, ___EmotionJSX("span", {
    css: styles.text
  }, agentText), ___EmotionJSX(ChevronRightIcon, {
    size: "small"
  })));
};